export default "__VITE_ASSET___OrocPIU__"